import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: fulfillmentUrl('products'),

  /* eslint consistent-return: 0 */
  count() {
    const inventories = this.get('inventories');
    if (!inventories) { return 0; }

    return inventories.reduce((count, inv) => count + inv.get('quantity'), 0);
  },

  getInventory(id) {
    const inventories = this.get('inventories');

    if (!inventories) {
      return {};
    }

    const inventory = inventories.reduce((obj, inv) => ({
      ...obj,
      [inv.get('warehouse').id]: {
        location: inv.get('warehouse').address,
        quantity: inv.get('quantity'),
      },
    }), {});

    if (id) { return inventory[id]; }
    return inventory;
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_product.js